import { render, staticRenderFns } from "./ownermoneychangeAduit.vue?vue&type=template&id=07068dd1&scoped=true"
import script from "./ownermoneychangeAduit.vue?vue&type=script&lang=js"
export * from "./ownermoneychangeAduit.vue?vue&type=script&lang=js"
import style0 from "./ownermoneychangeAduit.vue?vue&type=style&index=0&id=07068dd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07068dd1",
  null
  
)

export default component.exports